import { render } from "./p-table.vue?vue&type=template&id=fb1f139e&scoped=true"
import script from "./p-table.vue?vue&type=script&lang=js"
export * from "./p-table.vue?vue&type=script&lang=js"

import "./p-table.vue?vue&type=style&index=0&id=fb1f139e&scoped=true&lang=scss"
import "./p-table.vue?vue&type=style&index=1&id=fb1f139e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb1f139e"]])

export default __exports__